export const getCoursesByStatus = (finFilteredArr: any) => {
    return (!sessionStorage.getItem("isDemoUser")) ? finFilteredArr.filter((course: any) => (course.status === "3" || course.status === "1" || course.status === "5")) : finFilteredArr;
}

export interface Course {
    status: string;
}

export const getActiveCourse = (getTMSGetCourseData: Course[]) => {
    let activeCourseData: Array<any> | string = "0";

    if (getTMSGetCourseData.length > 0) {
        activeCourseData = getTMSGetCourseData.filter((course) => {
            const { status } = course;
            return status === "1" || status === "2" || status === "3" || status === "5";
        });

        activeCourseData = activeCourseData.length > 0 ? activeCourseData[activeCourseData.length - 1] : "0";
    }

    return activeCourseData;
};